<template>
  <div class="desktop_margin" style="height: 75vh">
    <AdminHeader
      v-bind:headerName="$t('newUi.forms.editForm', { form: header_name })"
      view_form=""
      :delete_form="payload.pos"
    />
    <v-overlay :value="set_overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <div class="desktopView pt-10">
      <div class="d-flex justify-space-between">
        <div class="justify-start">
          <!-- <h5 class="justify-content-start">{{payload.shopname}}</h5> -->
          <h5 class="justify-content-start">
            {{ $t("newUi.forms.editForm", { form: header_name }) }}
          </h5>
        </div>
        <div class="justify-end" style="font-size: 12px">
          <div class="row p-2 justify-content-end">
            <v-btn
              style="font-size: 12px"
              class="button_padding"
              color="#8AB26D"
              @click="delete_form_dialog = true"
            >
              {{ $t("newUi.editForm.deleteForm") }}
            </v-btn>
            <!-- <div class="link_heading pt-2">Your Form Link</div>
          <div class="col-4 background_color text-truncate text_color" >{{linkval}}</div>
            <span class="pt-2"><i class="bi bi-files icon_color" style="font-size: 14px; margin-bottom: 1px;" @click="doCopy"></i></span> -->
          </div>
        </div>
      </div>
    </div>
    <v-container
      v-if="!form_saved"
      class="desktop_background_editform vertical-align-middle section_form_middle"
      :style="$vuetify.breakpoint.height < 450 ? { 'margin-top': '20px' } : {}"
    >
      <v-container class="section_desktop" style="max-width: 550px">
        <v-text-field
          v-bind:label="$t('newUi.editForm.editName')"
          v-model="payload.shopname"
          placeholder=""
          v-bind:title="$t('')"
          required
        ></v-text-field>

        <v-textarea
          v-bind:label="$t('newUi.editForm.editDesc')"
          v-model="payload.shopdesc"
          required
          v-bind:title="$t('')"
          placeholder=""
          name="text"
          row="2"
          row-height="20"
        ></v-textarea>
        <v-select
          v-model="currency2"
          style="padding-top:22px"
          :items="this.items2"
          v-bind:label="this.placeHolderText()"
        ></v-select>
        <label class="whatsappText">
          {{ $t("newUi.editForm.whatsAppDesc") }}
        </label>
        <vue-tel-input
          :autoFormat="false"
          :showDialCode="true"
          :value="
            payload.nationalNumber ? payload.nationalNumber : payload.phone
          "
          v-model="mobileno"
          :validCharactersOnly="true"
          :defaultCountry="
            parseInt(
              payload.phone.replace(payload.nationalNumber, '').replace('+', '')
            )
          "
          :dropdownOptions="{
            showFlags: true,
            showDialCodeInList: true,
            showDialCodeInSelection: true,
          }"
          :inputOptions="{
            placeholder: $t('newUi.createOrderForm.phoneNumber'),
            maxlength: 16,
          }"
          @input="onInput"
          @country-changed="countryChanged"
          inputOptions.placeholder=""
          mode="international"
          id="create_for_mobile"
          @validate="onValidate"
          :enabledCountryCode="true"
          inputId="edit_for_mobile1"
        ></vue-tel-input>

        <div class="mobile_data desktopView mt-10">
          <v-btn @click="cancel" class="button_padding cancel_button">
            {{ $t("newUi.editForm.cancel") }}
          </v-btn>
          <v-btn @click.prevent="submit" class="button_padding submit_button">
            {{ $t("newUi.editForm.save") }}
          </v-btn>
        </div>
        <div class="mobile_data mobileview bottom_tab mt-20">
          <v-btn @click="cancel" class="button_padding cancel_button">
            {{ $t("newUi.editForm.cancel") }}
          </v-btn>
          <v-btn @click.prevent="submit" class="button_padding submit_button">
            {{ $t("newUi.editForm.save") }}
          </v-btn>
        </div>
      </v-container>
    </v-container>
    <v-dialog v-model="delete_form_dialog" content-class="crop-dialog">
      <v-container style="height: 200px; background-color: #fff">
        <div
          class="d-flex justify-end justify-content-end text_color"
          style="font-size: 14px"
        >
          <span class="cursor-pointer" @click="delete_form_dialog = false"
            >x</span
          >
        </div>
        <div class="text-center text_color">
          {{ $t("newUi.editForm.deleteForm") }}
        </div>
        <v-container class="text-center">
          <div>
            {{ $t("newUi.deleteForm.confirmDelete") }}
          </div>
          <v-spacer style="padding: 10px"></v-spacer>
          <div class="text-center" style="padding-left:12px">
            <v-btn
              color="#8AB26D"
              class="button_padding"
              @click="delete_form_dialog = false"
              >{{ $t("common.cancelButton") }}</v-btn
            >
            <v-btn
              color="#8AB26D"
              class="button_padding"
              @click="deleteFormFile(payload.pos)"
              >{{ $t("common.deleteButton") }}</v-btn
            >
          </div>
        </v-container>
      </v-container>
    </v-dialog>
  </div>
</template>
<script>
import { saveFile, setLocale } from "../services/firebase";
import {
  saveMasterData,
  deleteMasterData,
  deleteFile,
} from "../services/firebase";
import store from "../store/store";
import i18n from "../i18n";
import router from "../router/router";
import AdminHeader from "@/layout/adminHeader.vue";
import Currencies from "../assets/currency";
export default {
  name: "GsCatelogueEditForm",
  props: ["payload"],
  components: {
    AdminHeader,
  },
  data() {
    return {
      mobileno: this.payload.nationalNumber
        ? this.payload.nationalNumber
        : this.payload.phone,
      validateNumber: "hide",
      form_saved: false,
      phone: "",
      new_number: "",
      valid_number: "",
      phone_valid: "",
      delete_form_dialog: false,
      set_overlay: false,
      currency2: "",
      items2: [],
      previous_name: this.payload.shopname,
    };
  },
  mounted() {
    setLocale();
    for (const currency in Currencies) {
      var symbol = Currencies[currency];
      this.items2.push(currency + " - " + symbol["symbol"]);
    }
    this.currency2 =
      this.$store.state.currentForm.currency +
      " - " +
      this.$store.state.currentForm.symbol;
  },
  computed: {
    isValid: function() {
      return this.mobileno === "" ? true : this.valid;
    },
    header_name() {
      let name = "";
      if (this.payload.type == "Ordering form") {
        name = i18n.t("newUi.forms.order");
      } else {
        name = i18n.t("newUi.forms.cat");
      }
      return name;
    },
  },
  methods: {
    placeHolderText: function() {
      return i18n.t("newUi.adminViewform.currency");
    },
    addcateg: function() {
      var p = this.$store.state.currentForm.catalogue.maxlength;
      if (!p) {
        p = 1;
        this.$store.dispatch("setMaxLength", 1);
      } else {
        var maxlength = this.$store.state.currentForm.catalogue.maxlength + 1;
        p = maxlength;
        this.$store.dispatch("setMaxLength", maxlength);
      }
      this.$store.state.currentForm.catalogue.push({
        pos: p,
        type: "category",
        name: "",
      });
    },
    countryChanged(formattedNumber) {
      this.data = formattedNumber;
    },
    onInput(formattedNumber, { number, nationalNumber, valid }) {
      this.data = formattedNumber;
      this.phone_valid = valid;
      this.national_number = nationalNumber;
      this.new_number = number;
    },
    onValidate: function({ number, nationalNumber, valid }) {
      this.phone_valid = valid;
      if (valid == true) {
        this.new_number = number;
        this.national_number = nationalNumber;
      }
      // console.log(number, valid, country)
    },
    additem: function() {
      var p = this.$store.state.currentForm.catalogue.maxlength;
      if (!p) {
        p = 1;
        this.$store.dispatch("setMaxLength", 1);
      } else {
        var maxlength = this.$store.state.currentForm.catalogue.maxlength + 1;
        p = maxlength;
        this.$store.dispatch("setMaxLength", maxlength);
      }
      this.$store.state.currentForm.catalogue.push({
        pos: p,
        type: "item",
        name: "",
        desc: "",
        imageurl: "",
        price: 0,
        qtty: 0,
      });
    },
    delitem: function() {
      this.$store.state.currentForm.catalogue.pop();
    },
    submit: function() {
      if (
        this.currency2 &&
        this.currency2 != "" &&
        !this.currency2.includes("undefined")
      ) {
        this.payload.phone = this.new_number;
        this.payload.nationalNumber = this.national_number;
        this.saveCurrentForm();
      } else {
        alert(i18n.t("alertText.fillCurrency"));
      }
    },
    cancel: function() {
      router.push("/admin/viewform/" + this.$store.state.currentForm.pos);
    },
    validatePhone: function(phone) {
      var regex = /^\+(?:[0-9] ?){6,14}[0-9]$/;
      if (regex.test(phone)) {
        //this.validateNumber = "hide";
        return true;
      } else {
        //this.validateNumber = "display";
        return false;
      }
    },
    deleteFormFile: function(formlink) {
      var storedata = this.$store;
      this.$store.dispatch("setOverlay", true);
      this.set_overlay = true;
      this.delete_form_dialog = false;
      var storedata = this.$store;
      // this.$store.dispatch("setOverlay", true);
      var elethis = this;
      for (var i = 0; i < this.$store.state.forms.length; i++) {
        if (
          this.$store.state.forms[i].link.split("/")[3] ===
          window.location.href.split("/")[4]
        ) {
          // return new Promise((resolve, reject) => {
          this.$store.state.forms.splice(i, 1);
          deleteFile(
            this.$store.state.profile.uid,
            window.location.href.split("/")[4],
            function() {
              // storedata.dispatch("setOverlay", false);
              // elethis.set_overlay = false;
              console.log("forms ==> ", elethis.$store.state.forms);
            }
          ).then(() => {
            deleteMasterData(function(err) {
              console.log(err);
              return 0;
            }, this.$store.state).then(() => {
              elethis.set_overlay = false;
              // storedata.dispatch("setOverlay", false);
              router.push("/admin");
            });
          });
          break;
        }
      }
    },
    validatePrice: function() {
      var catelogue = this.$store.state.currentForm.catalogue;
      var data = {
        status: true,
        price: "",
      };
      if (catelogue.length > 0) {
        for (var i = 0; i < catelogue.length; i++) {
          if (catelogue[i].type == "item") {
            if (
              catelogue[i].price == "" ||
              parseFloat(catelogue[i].price) < 0 ||
              !parseFloat(catelogue[i].price)
            ) {
              data.status = false;
              data.price = catelogue[i].price;
              return data.status;
            }
          }
        }
        return data.status;
      } else {
        return data.status;
      }
    },
    saveCurrentForm: function() {
      var shopname = this.$store.state.currentForm.shopname;
      var phone = this.$store.state.currentForm.phone;
      this.$store.state.currentForm.currency = this.currency2
        ? this.currency2.split("-")[0].trim()
        : "";
      this.$store.state.currentForm.symbol = this.currency2
        ? this.currency2.split("-")[1].trim()
        : "";
      // this.$store.state.currentForm.createdOn = new Date()
      if (shopname == null || !shopname || shopname == "") {
        alert(i18n.t("alertText.validateNameAlert", { type: this.type }));
      } else if (shopname.length > 25) {
        alert(i18n.t("alertText.formMax"));
      } else if (phone == "+91" || this.phone_valid != true) {
        alert(i18n.t("alertText.validatePhoneAlert"));
      } else {
        var exists = false;
        this.$store.state.forms.map((element) => {
          if (
            this.previous_name != shopname &&
            element.shopname.toLowerCase().replace(/ /g, "") ===
              shopname.toLowerCase().replace(/ /g, "")
          ) {
            exists = true;
          }
        });
        if (!exists) {
          this.$store.dispatch("setOverlay", true);
          this.set_overlay = true;
          var elethis = this;
          saveFile(
            this.$store.state.profile.uid,
            this.$store.state.currentFormPos,
            JSON.stringify(this.$store.state.currentForm),
            function(error) {
              if (error) {
                //TODO skeleton data
                alert(i18n.t("alertText.saveFailed"));
                store.dispatch("setOverlay", false);
                elethis.set_overlay = false;
              } else {
                // alert(i18n.t("alertText.uploadText"));
                store.dispatch("setOverlay", false);
                elethis.set_overlay = false;
                router.push("/admin/viewform/" + store.state.currentForm.pos);
              }
            }
          );
          saveMasterData(function(err) {
            console.log(err);
          }, this.$store.state);
          this.form_saved = true;
        } else alert("Form Name Should Be Unique");
      }
    },
  },
};
</script>
<style lang="scss">
.button_padding {
  margin-right: 10px;
  padding: 10px;
  font-weight: bold;
  color: white !important;
  text-align: center;
  font-size: 12px;
  letter-spacing: 0px;
  text-transform: none;
  cursor: pointer;
}
.cancel_button {
  background-color: rgb(233, 80, 91) !important;
  border-color: rgb(233, 80, 91) !important;
}
.submit_button {
  background-color: rgb(18, 140, 126) !important;
  border-color: rgb(18, 140, 126) !important;
}
input[type="text"] {
  margin-bottom: 0px;
  border: none;
  margin-top: 0px;
}
.bottom_modal {
  border-top-right-radius: 20px;
  border-top-left-radius: 20px;
  border-bottom-left-radius: 0px;
  border-bottom-right-radius: 0px;
}
.invalid_color {
  border: 1px solid red;
}
.bottom_tab {
  width: 100%;
  text-align: center;
  left: 0;
  right: 0;
  margin-top: 130px;
}
.theme--light.v-input input {
  color: #8ab26d;
}
.text_color {
  color: #8ab26d;
  font-weight: bold;
}

@media (min-width: 320px) and (max-width: 960px) {
  .mobile_data {
    text-align: center;
  }
  .section_form_middle {
    display: flex;
    margin-top: 35%;
    justify-content: center;
  }
  .background_color {
    background-color: #f8faf7;
    padding: 10px;
    margin-bottom: 10px;
    width: 100%;
  }
  .whatsappText {
    text-align: left;
    font-size: 13px;
    letter-spacing: 0px;
    color: #7c7c7c;
    opacity: 1;
  }
  .section_middle {
    position: fixed;
    bottom: 10%;
  }
  .vue-tel-input {
    border: none;
  }
  .vti__dropdown {
    background-color: #f8faf7;
  }
  .vti__input {
    margin-left: 5px;
    background-color: #f8faf7;
  }
}
@media (min-width: 960px) {
  .desktop_background_editform {
    background-color: #f4f4f4;
    padding: 50px !important;
  }
  .desktop_margin {
    padding: 0rem 4rem;
  }
  .section_desktop {
    text-align: start;
    margin-left: 0px !important;
  }
  .section_form_middle {
    display: flex;
    margin-top: 40px;
  }
  .background_color {
    background: #f4f4f4 0% 0% no-repeat padding-box;
    opacity: 1;
    font-size: 12px;
    letter-spacing: 0px;
    color: #666666;
    opacity: 1;
    padding: 20px;
  }
  .whatsappText {
    text-align: left;
    font-size: 13px;
    letter-spacing: 0px;
    color: #7c7c7c;
    opacity: 1;
  }
  .vue-tel-input {
    border: none;
  }
  .vti__dropdown {
    background-color: #f8faf7;
  }
  .vti__input {
    margin-left: 5px;
    background-color: #f8faf7;
  }
}
.icon_color {
  color: #8ab26d;
  justify-content: center;
  font-size: 20px;
  width: 26px;
  height: 26px;
  background-color: #f8faf7;
  padding: 5px;
  margin: 3px;
  border-radius: 3px;
}
</style>
